// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__2W4M7","overlay":"Dialog_overlay__238av","content":"Dialog_content__2wph7","close":"Dialog_close__YvWhF","icon":"Dialog_icon__EkxN8"};